// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Button } from './button';

/**
 * @class Jsw.BigButton
 * @extends Jsw.Button
 */
export const BigButton = Class.create(Button, {
    _initConfiguration($super, config) {
        config = Object.extend({
            cls: 'tool-block',
            disabledClass: 'tool-block-disabled',
        }, config || {});
        $super(config);
    },

    _initComponentElement($super) {
        $super();

        let button = '';
        if (this._getConfigParam('title')) {
            button += `<span class="tool-name">${this._getConfigParam('title').escapeHTML()}</span>`;
        }

        let description = '';
        if (Object.isArray(this._getConfigParam('additionalComments'))) {
            this._getConfigParam('additionalComments').each(function (comment) {
                description += `${comment.escapeHTML()}<br/>`;
            });
            description = `<span>${description}</span>`;
        }
        if (this._getConfigParam('comment')) {
            description += this._getConfigParam('comment').escapeHTML();
        }
        if (description.length) {
            button += `<span class="tool-info">${description}</span>`;
        }
        if (this._getConfigParam('icon')) {
            const icon = '<span class="tool-icon">' +
                    `<img src="${this._getConfigParam('icon')}">` +
                '</span>';
            button = icon + button;
        }
        this._componentElement.update(button);
    },

    _addProgressHandler() {
        if (this._getConfigParam('indicateProgress', false)) {
            this.addEventObserver('click', function () {
                this._componentElement.style.display = 'none';
                this._componentElement.up().insert(`<div class="ajax-loading">${this._config.waitMessage}</div>`);
            }.bind(this));
        }
    },
});



// WEBPACK FOOTER //
// ./jsw/big-button.js